import { iframeResizer } from 'iframe-resizer';
import React, { useEffect, useRef } from 'react';
import config from 'src/config';
import { AppRoutes } from 'src/pages/app';
import { processQueryResult, ProductTypeCodeEnum, } from 'src/common';
import { useGetWsPayPaymentDataQuery } from 'src/common/api/apollo/additional';
import { useGetWsPayPaymentDataQuery as useSupplementaryWsPayPaymentDataQuery } from 'src/common/api/apollo/supplementary';

export enum HealthOfferPaymentOptionEnum {
  CreditCard ='creditCard',
  GeneralTransfer = 'generalTransfer',
  KeksPay = 'keksPay',
  Aircash = 'aircash',
}


export interface WsPayIframeProps {
  offerId: string;
  paymentType: string;
  paymentOption: HealthOfferPaymentOptionEnum;
  installments?: boolean;
  onLoad?: () => void;
  type?: ProductTypeCodeEnum.DOPUNSKO | ProductTypeCodeEnum.DODATNO;
}

const snapshot = (fields: Record<string, string | undefined | null>) =>
  JSON.stringify(Object.keys(fields).sort().reduce((acc, k) => ({ ...acc, [k]: fields[k] }), {}));

export const WsPayIframe = ({ offerId, paymentType, paymentOption, installments = false, onLoad, type = ProductTypeCodeEnum.DOPUNSKO }: WsPayIframeProps) => {
  const formRef = useRef<HTMLFormElement>(null);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const lastSnapshot = useRef<string | null>(null);
  const uniqueId = `wsPay-iframe-${paymentOption}${installments ? '-installments' : '-onetime'}`;

  const { loading, error, data } = useSupplementaryWsPayPaymentDataQuery({
    variables: { id: offerId, input: { paymentOption, paymentType, installment: 1 } }, // Fake-ano da se uvijek šalje 1 jer nema razlike u cijeni
    fetchPolicy: 'cache-first',
    skip: type !== ProductTypeCodeEnum.DOPUNSKO,
    onCompleted: (result: any) => {
      processQueryResult(result);
      if (formRef.current) {
        formRef.current.submit();
      }
    },
  });
  const { loading: additionalLoading, error: additionalError, data: additionalData } = useGetWsPayPaymentDataQuery({
    variables: { id: offerId, input: { paymentOption, paymentType, installment: 1 } },
    fetchPolicy: 'cache-first',
    skip: type !== ProductTypeCodeEnum.DODATNO,
    onCompleted: (result: any) => {
      processQueryResult(result);
      if (formRef.current) {
        formRef.current.submit();
      }
    },
  });

  const myUrl = [config.REACT_APP_URL];
  // Destrukturiranje podataka
  const { getWSPayPaymentData: supplementaryWsPayData } = data || {};
  const { getWSPayPaymentData } = additionalData || {};
  const hiddenFields = {
    ...(type === ProductTypeCodeEnum.DOPUNSKO ? supplementaryWsPayData : getWSPayPaymentData),
    PaymentPlan: installments ? undefined : '0000', // Dok je gore fake-ano i uvijek se šalje installments = 1, checkoutHealthOfferWSPayPaymentDetails!.PaymentPlan je uvijek 0000
    ReturnURL: type === ProductTypeCodeEnum.DOPUNSKO ? [myUrl, AppRoutes.CHECKOUT_SUCCESS.fullPath].join('') : getWSPayPaymentData?.ReturnURL,
    CancelURL: type === ProductTypeCodeEnum.DOPUNSKO ? [[myUrl, AppRoutes.CHECKOUT.fullPath].join(''), offerId].join('/') : getWSPayPaymentData?.CancelURL,
    ReturnErrorURL: type === ProductTypeCodeEnum.DOPUNSKO ? [myUrl, AppRoutes.CHECKOUT_FAILURE.fullPath].join('') : getWSPayPaymentData?.ReturnErrorURL,
    Iframe: '1',
    Version: '2.0',
  };

  const fieldsSnapshot = loading || error || additionalLoading || additionalError ? '' : snapshot(hiddenFields);

  useEffect(() => {
    if (fieldsSnapshot === '') return;
    if (lastSnapshot.current === fieldsSnapshot) return;
    if (lastSnapshot.current === null) {
      lastSnapshot.current = fieldsSnapshot;
      return;
    }
    lastSnapshot.current = fieldsSnapshot;
    formRef.current?.submit();
  }, [fieldsSnapshot]);

  if (type === ProductTypeCodeEnum.DOPUNSKO && (loading || error)) return null;
  if (type === ProductTypeCodeEnum.DODATNO && (additionalLoading || additionalError)) return null;

  const renderHiddenFields = (fields: { [key: string]: string | undefined | null }) =>
    Object.keys(fields).map((key) => {
      if (fields[key] === undefined || fields[key] === null) return null;
      return <input key={key} type="hidden" name={key} value={fields[key]!} />;
    });

  return (
    <div>
      <form ref={formRef} name="pay" action={config.REACT_APP_WSPAY_URL} method="POST" target={uniqueId}>
        {renderHiddenFields(hiddenFields)}
      </form>
      <iframe
        ref={iframeRef}
        key={uniqueId}
        name={uniqueId}
        id={uniqueId}
        style={{ width: '100%', minHeight: '420px', border: 'none' }}
        onLoad={() => {
          iframeResizer({ checkOrigin: false }, `#${uniqueId}`);

          if (onLoad) {
            onLoad();
          }
        }}
      ></iframe>
    </div>
  );
};
